import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexLendCategory from "./settings/lendCategories/IndexLendCategory";
import IndexLendType from "./settings/lendTypes/IndexLendType";
import IndexCompanyLends from "./lends/companyLends/IndexCompanyLends";
import IndexLendApprovals from "./lends/lendApprovals/IndexLendApprovals";
import IndexLendRepayments from "./lendRepayments/IndexLendRepayments";
import { useSelector } from "react-redux";
import { guardElement } from "@comps/components";

const LendManagementModuls = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  return (
    <Routes>
      <Route path="settings/categories" element={ guardElement(<IndexLendCategory modkey="lendCategories"/>, "lendCategories") } />
      <Route path="settings/types" element={ guardElement(<IndexLendType modkey="lendTypes"/>, "lendTypes") } />
      <Route path="lends/company-requests" element={ guardElement(<IndexCompanyLends filters={ '' } module="company-requests" modkey="companyLends"/>, "companyLends") } />
      <Route path="lends/requests" element={ guardElement(<IndexCompanyLends user={ authUser } filters={ `employee_|${authUser.employment_id}` } module="my-requests" modkey="lendRequests"/>, "lendRequests") } />
      <Route path="lends/approvals" element={ guardElement(<IndexLendApprovals api='lendApprovals' modkey="lendApprovals"/>, "lendApprovals") } />
      <Route path="lends/delegates" element={ guardElement(<IndexLendApprovals api='lendDelegates' modkey="lendDelegates"/>, "lendDelegates") } />
      <Route path="repayments" element={ guardElement(<IndexLendRepayments modkey="lendRepayments"/>, "lendRepayments") } />
    </Routes>
  );
}

export default LendManagementModuls;
